import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LostPetReportPage from "./LostPetReportPage";
import VetAppointmentWizardPage from "./VetAppointmentWizardPage";
import ThankYouPage from "./ThankYouPage";
import PetAlertChat from "./PetAlertChat";


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/:tagId" element={<LostPetReportPage />} />
              <Route path="/" element={<LostPetReportPage />} />
              <Route path="/vet-appointment/:tagId" element={<VetAppointmentWizardPage />} />
              <Route path="/thank-you" element={<ThankYouPage />} />
              <Route path="/chat" element={<PetAlertChat />} />
      </Routes>
    </Router>
  );
}

export default App;
